/* =========================================================
   HeroPack product polish v39
   Move this file to Assets as: hp-product-polish-v39.js
   ========================================================= */
(function(){

  function normText(value){
    return String(value || '')
      .replace(/\s+/g,' ')
      .replace(/[־–—]/g,'-')
      .trim();
  }

  function escapeHtml(value){
    return String(value || '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  function isProductPage(){
    return document.body.classList.contains('template-product') ||
      document.documentElement.classList.contains('hp-product-page') ||
      window.location.pathname.indexOf('/products/') !== -1;
  }

  function fixTopProductBulletsInDescription(){
    if(!isProductPage()) return;

    var desc = document.querySelector(
      'body.template-product .product__info-container .product__description, html.hp-product-page .product__info-container .product__description'
    );

    if(!desc || desc.dataset.hpBulletsFixed === '1') return;

    var rawText = normText(desc.textContent);
    var checkCount = (rawText.match(/✓/g) || []).length;

    if(checkCount < 2) return;
    if(desc.querySelector('ul,ol,li')) return;

    var html = desc.innerHTML;
    var lines = html
      .split(/<br\s*\/?>/i)
      .map(function(line){
        return line
          .replace(/<\/?[^>]+(>|$)/g,'')
          .replace(/\s+/g,' ')
          .trim();
      })
      .filter(Boolean);

    if(lines.length < 2) return;

    var newHtml = lines.map(function(line){
      var isBullet = line.indexOf('✓') !== -1;

      if(!isBullet){
        return '<div class="hp-product-intro-line">' + escapeHtml(line) + '</div>';
      }

      var clean = line.replace(/✓/g,'').trim();

      return '<div class="hp-product-bullet-line">' +
        '<span class="hp-product-bullet-mark">✓</span>' +
        '<span class="hp-product-bullet-text">' + escapeHtml(clean) + '</span>' +
      '</div>';
    }).join('');

    desc.innerHTML = '<div class="hp-product-bullets-fixed">' + newHtml + '</div>';
    desc.dataset.hpBulletsFixed = '1';
  }

  function fixSeparateProductTextBullets(){
    if(!isProductPage()) return;

    var container = document.querySelector(
      'body.template-product .product__info-container, html.hp-product-page .product__info-container'
    );

    if(!container) return;

    var nodes = Array.prototype.slice.call(container.children || []);

    var candidates = nodes.filter(function(el){
      if(!el || el.dataset.hpSingleBulletFixed === '1') return false;
      if(el.closest('form, .product-form, .price, variant-radios, variant-selects, .product__accordion, details, .shopify-payment-button, media-gallery')) return false;

      var text = normText(el.textContent);
      if(text.indexOf('✓') === -1) return false;
      if(text.length > 120) return false;

      return true;
    });

    if(candidates.length < 2) return;

    candidates.forEach(function(el){
      var clean = normText(el.textContent).replace(/✓/g,'').trim();
      if(!clean) return;

      el.classList.add('hp-product-single-bullet-fixed');
      el.setAttribute('dir','rtl');

      el.innerHTML =
        '<span class="hp-product-bullet-mark">✓</span>' +
        '<span class="hp-product-bullet-text">' + escapeHtml(clean) + '</span>';

      el.dataset.hpSingleBulletFixed = '1';
    });
  }

  function fixMaxUpsellTitle(){
    var candidates = document.querySelectorAll(
      '#MainContent h1, #MainContent h2, #MainContent h3, #MainContent .title, #MainContent [class*="title"], #MainContent [class*="heading"]'
    );

    candidates.forEach(function(el){
      if(el.closest('cart-drawer, #CartDrawer, .cart-drawer')) return;
      if(el.closest('.product, .product__info-container, .product__media-wrapper')) return;
      if(el.dataset.hpMaxTitlePolished === '1') return;

      var text = normText(el.textContent);

      if(
        text.indexOf('שדרגו') === -1 ||
        text.indexOf('HeroPack') === -1 ||
        text.indexOf('MAX') === -1
      ){
        return;
      }

      el.classList.add('hp-max-title-polish');
      el.dataset.hpMaxTitlePolished = '1';

      el.innerHTML =
        '<span class="hp-max-title-small">שדרגו ל־</span>' +
        '<span class="hp-max-title-main">HeroPack MAX</span>';

      var section =
        el.closest('.shopify-section') ||
        el.closest('section') ||
        el.parentElement;

      if(section){
        section.classList.add('hp-max-upsell-section-polish');
      }
    });
  }

  function runHpProductPolishV39(){
    fixTopProductBulletsInDescription();
    fixSeparateProductTextBullets();
    fixMaxUpsellTitle();
  }

  runHpProductPolishV39();

  document.addEventListener('DOMContentLoaded', runHpProductPolishV39);
  window.addEventListener('load', function(){
    setTimeout(runHpProductPolishV39,150);
    setTimeout(runHpProductPolishV39,700);
  });
  window.addEventListener('resize', function(){
    setTimeout(runHpProductPolishV39,150);
  });
  document.addEventListener('shopify:section:load', function(){
    setTimeout(runHpProductPolishV39,150);
  });

})();
